var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return !_vm.$freeParticulier() || _vm.form.bilans.length > 0 ? _c('div', {
    on: {
      "keydown": function ($event) {
        return _vm.progressbar.userKeyDown();
      },
      "keyup": function ($event) {
        return _vm.progressbar.userKeyUp();
      },
      "click": _vm.calculate_progress
    }
  }, [_c('h3', {
    staticClass: "m-5 md:m-15 2xl:m-20"
  }, [_vm._v("Bilans")]), _vm._v(" "), _vm.$can(_vm.infosPage.name_page + '_edit', _vm.infosPass.id_pass) ? _c('add-button', {
    staticClass: "mx-5 md:mx-15 2xl:mx-20",
    attrs: {
      "libelle": "Ajouter un bilan"
    },
    on: {
      "add": function ($event) {
        return _vm.addBilan();
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.form.bilans.length > 0 ? _c('div', [_c('list-grid', {
    ref: "listBilans",
    attrs: {
      "list-items": _vm.form.bilans,
      "is-accordion-items": true
    },
    on: {
      "displayNum": function (index) {
        _vm.bilanDisplayed = index;
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function () {
        return [_c('div', {
          staticClass: "hidden md:block md:col-start-2 md:col-span-2"
        }, [_vm._v("Date")]), _vm._v(" "), _c('div', {
          staticClass: "col-start-3 col-span-4 md:col-span-3"
        }, [_vm._v("Type")]), _vm._v(" "), _c('div', {
          staticClass: "col-span-6 md:col-span-3"
        }, [_vm._v("Période")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block col-span-2"
        }, [_vm._v("Extrait du bilan")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-1"
        })];
      },
      proxy: true
    }, {
      key: "accordionDescription",
      fn: function (_ref) {
        var item = _ref.item,
          num = _ref.num;
        return [_c('icon', {
          staticClass: "text-pink-600 col-span-2 md:col-span-1 place-self-center transform transition-transform ease-in-out duration-300",
          class: {
            'rotate-90': _vm.bilanDisplayed == num
          },
          attrs: {
            "name": "chevron-right"
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2 text-base font-normal"
        }, [item.date_saisie_bilan ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.date_saisie_bilan).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.date_saisie_bilan).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.date_saisie_bilan).getFullYear()) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "col-span-4 md:col-span-3"
        }, [_c('tag', {
          staticClass: "hidden md:block",
          attrs: {
            "libelle": item.type_accompagnement,
            "theme-color": item.type_accompagnement == 'Professionnel' ? 'indigo' : item.type_accompagnement == 'Personnel' ? 'pink' : item.type_accompagnement == 'Socio-professionnel' ? 'teal' : null
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "text-base md:hidden",
          class: {
            'text-indigo-600': item.type_accompagnement == 'Professionnel',
            'text-pink-600': item.type_accompagnement == 'Personnel',
            'text-teal-600': item.type_accompagnement == 'Socio-professionnel'
          }
        }, [_vm._v("\n            " + _vm._s(item.type_accompagnement) + "\n          ")])], 1), _vm._v(" "), _c('div', {
          staticClass: "col-span-6 md:col-span-3 text-base font-normal"
        }, [item.date_debut ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.date_debut).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.date_debut).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.date_debut).getFullYear()) + "\n          ")]) : _vm._e(), _vm._v("\n          -\n          "), item.date_fin ? _c('span', [_vm._v("\n            " + _vm._s(('0' + new Date(item.date_fin).getDate()).slice(-2)) + "/" + _vm._s(('0' + (new Date(item.date_fin).getMonth() + 1)).slice(-2)) + "/" + _vm._s(new Date(item.date_fin).getFullYear()) + "\n          ")]) : _vm._e()]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-2 text-sm italic mr-10 truncate"
        }, [_vm._v("\n          " + _vm._s(item.bilan_annee_ecoulee) + "\n        ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden md:block md:col-span-1"
        }, [_vm.$can(_vm.constants.PERMISSION_NEOPASS_EXPORT) ? _c('circle-button', {
          attrs: {
            "icon": "download",
            "label": "Exporter le bilan en PDF"
          },
          on: {
            "buttonClick": function ($event) {
              return _vm.exportToPDF(item);
            }
          }
        }) : _vm._e()], 1)];
      }
    }, {
      key: "accordionContent",
      fn: function (_ref2) {
        var item = _ref2.item,
          num = _ref2.num;
        return [_c('div', {
          staticClass: "grid grid-cols-12 gap-x-4 gap-y-10"
        }, [_c('input-select', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "type_accompagnement",
            "necessary": true,
            "libelle": "Type d'accompagnement",
            "size": "3",
            "value": item.type_accompagnement,
            "datas": [{
              value: 'Professionnel'
            }, {
              value: 'Personnel'
            }, {
              value: 'Socio-professionnel'
            }]
          },
          on: {
            "input": function (newValue) {
              item.type_accompagnement = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text', {
          staticClass: "md:col-span-6",
          attrs: {
            "name": "referent_accompagnateur",
            "libelle": "Référent accompagnateur",
            "necessary": true,
            "value": item.referent_accompagnateur
          },
          on: {
            "input": function (newValue) {
              item.referent_accompagnateur = newValue;
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-6",
          attrs: {
            "name": "date_saisie_bilan",
            "necessary-date": true,
            "libelle": "Date de saisie du bilan",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.date_saisie_bilan
          },
          on: {
            "input": function (newValue) {
              item.date_saisie_bilan = newValue;
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "date_debut",
            "necessary-date": true,
            "libelle": "Date de début",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "value": item.date_debut
          },
          on: {
            "input": function (newValue) {
              if (item.date_fin == '' && item.date_fin == null || _vm.$verifyDates({
                debut: newValue,
                fin: item.date_fin
              })) {
                item.date_debut = newValue;
              } else {
                _vm.badDates();
                item.date_debut = '';
              }
              _vm.sortBilans();
            }
          }
        }), _vm._v(" "), _c('date-picker', {
          staticClass: "col-span-full md:col-span-3",
          attrs: {
            "name": "date_fin",
            "necessary-date": true,
            "libelle": "Date de fin",
            "format": "dd/MM/yyyy",
            "initialview": "year",
            "direction": "left",
            "value": item.date_fin
          },
          on: {
            "input": function (newValue) {
              if (item.date_debut == '' && item.date_debut == null || _vm.$verifyDates({
                debut: item.date_debut,
                fin: newValue
              })) {
                item.date_fin = newValue;
              } else {
                _vm.badDates();
                item.date_fin = '';
              }
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full text-base text-indigo-600 uppercase"
        }, [_vm._v("\n            Lier le bilan à un projet\n          ")]), _vm._v(" "), _c('add-button', {
          staticClass: "w-max",
          attrs: {
            "libelle": "Ajouter un projet"
          },
          on: {
            "add": function ($event) {
              return _vm.addProject(num);
            }
          }
        }), _vm._v(" "), _vm._l(item.projets, function (projet, ip) {
          return _c('div', {
            key: 'projet' + ip,
            staticClass: "col-span-full grid grid-cols-12 gap-x-4 gap-y-10"
          }, [_c('div', {
            staticClass: "col-span-full md:col-span-6 flex space-x-4 items-end"
          }, [_c('delete-button', {
            staticClass: "w-max mb-2",
            on: {
              "del": function ($event) {
                return _vm.deleteItem(_vm.form.bilans[num].projets, ip, false);
              }
            }
          }), _vm._v(" "), _c('input-select', {
            attrs: {
              "name": 'projet_name' + num + ip,
              "necessary": true,
              "libelle": "Projet",
              "size": "3",
              "value": projet,
              "datas": _vm.projets,
              "value-is-object": true
            },
            on: {
              "input": function (newValue) {
                _vm.chooseProject(num, ip, newValue);
              }
            }
          })], 1), _vm._v(" "), _c('input-text-area', {
            staticClass: "md:col-start-1 md:col-span-6",
            attrs: {
              "name": 'resultat_projet' + num + ip,
              "necessary": true,
              "libelle": "Résultat du projet",
              "size": "3",
              "value": projet.resultat_projet,
              "disabled": true
            },
            on: {
              "input": function (newValue) {
                projet.resultat_projet = newValue;
              }
            }
          })], 1);
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full text-base text-indigo-600"
        }, [_vm._v("\n            BILAN ET FAITS MARQUANTS\n          ")]), _vm._v(" "), _c('input-text-area', {
          attrs: {
            "name": "bilan_annee_ecoulee",
            "necessary": true,
            "libelle": "Bilan de l'année écoulée (ou des 2 années écoulées)",
            "size": "3",
            "value": item.bilan_annee_ecoulee
          },
          on: {
            "input": function (newValue) {
              item.bilan_annee_ecoulee = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          attrs: {
            "name": "faits_marquants_annee",
            "necessary": true,
            "libelle": "Les faits marquants de cette année (ou ces 2 années écoulées) sur lesquels vous souhaitez-revenir?",
            "size": "3",
            "value": item.faits_marquants_annee
          },
          on: {
            "input": function (newValue) {
              item.faits_marquants_annee = newValue;
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full grid grid-cols-2 gap-4"
        }, [_c('div', {
          staticClass: "col-span-full md:col-span-1 text-base text-indigo-600"
        }, [_vm._v("\n              POSITIONNEMENT DU BÉNÉFICIAIRE\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "hidden lg:block md:col-span-1 text-base text-indigo-600"
        }, [_vm._v("\n              POSITIONNEMENT DU REFERENT\n            ")])]), _vm._v(" "), _c('div', {
          staticClass: "col-span-full grid grid-flow-col grid-rows-4 grid-cols-2 gap-x-4 gap-y-10"
        }, [_c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "acquis_pointsforts_beneficiaire",
            "necessary": true,
            "libelle": "Acquis/points forts",
            "size": "3",
            "value": item.acquis_pointsforts_beneficiaire
          },
          on: {
            "input": function (newValue) {
              item.acquis_pointsforts_beneficiaire = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "difficultes_beneficiaire",
            "necessary": true,
            "libelle": "Difficultés rencontrées",
            "size": "3",
            "value": item.difficultes_beneficiaire
          },
          on: {
            "input": function (newValue) {
              item.difficultes_beneficiaire = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "progres_beneficiaire",
            "necessary": true,
            "libelle": "Axes de progrès/axes à approndir",
            "size": "3",
            "value": item.progres_beneficiaire
          },
          on: {
            "input": function (newValue) {
              item.progres_beneficiaire = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "observations_beneficiaire",
            "necessary": true,
            "libelle": "Observations/infos complémentaires",
            "size": "3",
            "value": item.observations_beneficiaire
          },
          on: {
            "input": function (newValue) {
              item.observations_beneficiaire = newValue;
            }
          }
        }), _vm._v(" "), _c('div', {
          staticClass: "col-span-full lg:hidden md:col-span-1 text-base text-indigo-600"
        }, [_vm._v("\n              POSITIONNEMENT DU REFERENT\n            ")]), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "acquis_pointsforts_referent",
            "necessary": true,
            "libelle": "Acquis/points forts",
            "size": "3",
            "value": item.acquis_pointsforts_referent
          },
          on: {
            "input": function (newValue) {
              item.acquis_pointsforts_referent = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "difficultes_referent",
            "necessary": true,
            "libelle": "Difficultés rencontrées",
            "size": "3",
            "value": item.difficultes_referent
          },
          on: {
            "input": function (newValue) {
              item.difficultes_referent = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "progres_referent",
            "necessary": true,
            "libelle": "Axes de progrès/axes à approndir",
            "size": "3",
            "value": item.progres_referent
          },
          on: {
            "input": function (newValue) {
              item.progres_referent = newValue;
            }
          }
        }), _vm._v(" "), _c('input-text-area', {
          staticClass: "lg:row-span-1 md:col-span-1",
          attrs: {
            "name": "observations_referent",
            "necessary": true,
            "libelle": "Observations/infos complémentaires",
            "size": "3",
            "value": item.observations_referent
          },
          on: {
            "input": function (newValue) {
              item.observations_referent = newValue;
            }
          }
        })], 1), _vm._v(" "), _c('delete-button', {
          staticClass: "col-span-full md:col-span-3 w-max",
          attrs: {
            "libelle": "Supprimer ce bilan"
          },
          on: {
            "del": function ($event) {
              return _vm.deleteItem(_vm.form.bilans, num);
            }
          }
        })], 2)];
      }
    }], null, false, 808214395)
  })], 1) : _vm._e()], 1) : _c('div', [_c('h3', {
    staticClass: "my-15 w-full"
  }, [_vm._v("Aucun bilan")]), _vm._v(" "), _vm.$hasAtLeastOneGuest() ? _c('div', [_vm._m(0)]) : _vm._e(), _vm._v(" "), !_vm.$hasAtLeastOneGuest() ? _c('div', [_c('div', {
    staticClass: "text-gray-600 text-lg text-center"
  }, [_c('p', [_vm._v("\n        Veuillez ajouter un\n        "), _c('router-link', {
    attrs: {
      "to": {
        name: 'PermissionsGuests'
      }
    }
  }, [_c('span', {
    staticClass: "cursor-pointer text-indigo-500 underline"
  }, [_vm._v("invité")])]), _vm._v("\n        pour accéder à cette évaluation.\n      ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center w-full"
  }, [_c('illustration', {
    staticClass: "mt-15",
    attrs: {
      "name": "notAllowed"
    }
  })], 1)]) : _vm._e()]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "text-gray-600 text-lg text-center"
  }, [_c('p', [_vm._v("Il n'y a aucun bilan enregistré.")])]);

}]

export { render, staticRenderFns }